// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mat-dialog-container {
  padding: 0 !important;
  overflow: hidden;
}

.dialog-title {
  padding: 20px 24px 16px 24px;
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f8f9fa;
}

.dialog-content {
  padding: 24px;
  font-size: 13px;
  color: #333;
  max-height: 70vh;
  overflow-y: auto;
}

.dialog-actions {
  padding: 16px 24px;
  margin: 0;
  border-top: 1px solid #e0e0e0;
  background-color: #f8f9fa;
  display: flex;
  justify-content: flex-end;
}

.Btn_confirm {
  min-width: 80px;
  padding: 6px 16px;
  font-size: 12px;
  border: 1px solid rgba(120, 130, 140, 0.13);
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
  transition: all 0.2s ease;
}

.Btn_confirm:focus {
  background-color: #ffffff !important;
  color: black !important;
  border: 1px solid rgba(120, 130, 140, 0.2) !important;
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.Btn_confirm:hover {
  background-color: #f8f9fa !important;
  color: rgba(0, 0, 0, 0.87) !important;
  border: 1px solid rgba(120, 130, 140, 0.2) !important;
  box-shadow: inset 0 -10rem 0px rgba(158, 158, 158, 0.2);
}

.info-section {
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.info-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.info-label {
  min-width: 90px;
  color: #495057;
  font-weight: 600;
}

.info-value {
  color: #6c757d;
  word-break: break-word;
}

.mappings-section .section-title {
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 12px;
}

.no-mappings {
  padding: 16px;
  text-align: center;
  font-style: italic;
  color: #999;
}

.mapping-card {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
}
.mapping-card:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.mapping-card-body {
  padding: 16px;
}

.mapping-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 12px;
}

.mapping-info {
  flex: 1;
  min-width: 0;
}

.mapping-label {
  margin-bottom: 6px;
}
.mapping-label strong {
  color: #495057;
  margin-right: 6px;
}

.mapping-alias {
  color: #007bff;
  font-weight: 500;
}

.mapping-path {
  margin-top: 4px;
  margin-bottom: 8px;
}
.mapping-path small {
  font-size: 11px;
  word-break: break-all;
  display: block;
  line-height: 1.4;
}

.pending-badge {
  font-size: 11px;
  padding: 4px 8px;
  margin-top: 6px;
  display: inline-block;
  background-color: #f0ad4e;
  color: #fff;
  border-radius: 0.25rem;
  font-weight: bold;
}

.mapping-actions {
  display: flex;
  align-items: flex-start;
  flex-shrink: 0;
}

.action-btn {
  padding: 6px 12px;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
  font-weight: 500;
  transition: all 0.2s ease;
}
.action-btn.btn-danger {
  background-color: #d9534f;
  border-color: #d9534f;
  color: #fff;
}
.action-btn.btn-danger:hover:not([disabled]) {
  background-color: #c9302c;
  border-color: #c12e2a;
}
.action-btn.btn-secondary {
  background-color: #fff;
  border-color: rgba(120, 130, 140, 0.13);
  color: rgba(0, 0, 0, 0.87);
}
.action-btn.btn-secondary:hover:not([disabled]) {
  background-color: #f8f9fa;
  border-color: rgba(120, 130, 140, 0.2);
}
.action-btn i {
  margin-right: 4px;
}

.mapping-condition {
  padding-top: 12px;
  border-top: 1px solid #e9ecef;
  margin-top: 12px;
}
.mapping-condition strong {
  color: #495057;
  margin-right: 6px;
}

.condition-value {
  color: #6c757d;
  font-family: "Courier New", monospace;
  font-size: 11px;
  word-break: break-all;
}

.add-mapping-card {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background-color: #fff;
  overflow: hidden;
  margin-top: 20px;
}

.add-mapping-header {
  padding: 12px 16px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}
.add-mapping-header h6 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #495057;
}

.highlight-active {
  background-color: #17a2b8 !important;
  color: white !important;
  border-left: 4px solid #0c5460;
}
.highlight-active h6 {
  color: white !important;
}

.add-mapping-body {
  padding: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #495057;
  font-size: 13px;
}

.form-control {
  padding: 10px 12px;
  font-size: 13px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.form-control:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-control-lg {
  padding: 12px 14px;
  font-size: 14px;
}

.form-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 16px;
  border-top: 1px solid #e9ecef;
}

.action-btn-primary {
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 4px;
  background-color: #0275d8;
  border-color: #0275d8;
  color: #fff;
}
.action-btn-primary:hover:not([disabled]) {
  background-color: #025aa5;
  border-color: #01549b;
}
.action-btn-primary[disabled] {
  opacity: 0.65;
  cursor: not-allowed;
}
.action-btn-primary i {
  margin-right: 6px;
}

.action-btn-secondary {
  padding: 8px 16px;
  font-size: 13px;
  border-radius: 4px;
  background-color: #fff;
  border-color: rgba(120, 130, 140, 0.13);
  color: rgba(0, 0, 0, 0.87);
}
.action-btn-secondary:hover:not([disabled]) {
  background-color: #f8f9fa;
  border-color: rgba(120, 130, 140, 0.2);
}
.action-btn-secondary i {
  margin-right: 6px;
}

.info-text {
  color: #6c757d;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
}
.info-text i {
  margin-right: 4px;
}

.add-mapping-button-section {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e9ecef;
}

.add-mapping-btn {
  padding: 10px 20px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 4px;
  background-color: #5cb85c;
  border-color: #5cb85c;
  color: #fff;
}
.add-mapping-btn:hover:not([disabled]) {
  background-color: #449d44;
  border-color: #419641;
}
.add-mapping-btn i {
  margin-right: 6px;
}

.expression-builder-section {
  margin-top: 1rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.expression-toggle {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}
.expression-toggle label {
  margin-left: 0.5rem;
  margin-bottom: 0;
  cursor: pointer;
}

.function-select {
  margin-bottom: 1rem;
}

.parameter-form .param-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}
.parameter-form .param-row label {
  min-width: 120px;
  margin-bottom: 0;
  font-weight: 500;
}
.parameter-form .param-row input, .parameter-form .param-row select {
  flex: 1;
  margin-left: 0.5rem;
}

.expression-preview {
  margin-top: 1rem;
  padding: 0.75rem;
  background-color: #e9ecef;
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.9em;
  word-break: break-all;
}

.function-description {
  font-size: 0.85em;
  color: #6c757d;
  font-style: italic;
  margin-bottom: 0.75rem;
}

.category-label {
  font-weight: 600;
  color: #495057;
  font-size: 0.8em;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.repeatable-indicator .alert-info {
  background-color: #e7f3ff;
  border: 1px solid #b6d7f5;
  border-left: 4px solid #17a2b8;
  border-radius: 4px;
  padding: 12px 16px;
  font-size: 13px;
  color: #0c5460;
}
.repeatable-indicator .alert-info i {
  color: #17a2b8;
  font-size: 16px;
}
.repeatable-indicator .alert-info strong {
  color: #0c5460;
}
.repeatable-indicator .alert-info p {
  color: #0c5460;
  font-size: 12px;
  line-height: 1.5;
}
.repeatable-indicator .alert-info code {
  background-color: #d1ecf1;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: "Courier New", monospace;
  font-size: 12px;
  color: #0c5460;
}
.repeatable-indicator .auto-expression-preview {
  margin-top: 12px;
}
.repeatable-indicator .auto-expression-preview .form-label {
  margin-bottom: 6px;
  font-size: 12px;
}
.repeatable-indicator .auto-expression-preview .expression-code {
  background-color: #f4f4f4;
  border: 1px solid #ddd;
  border-left: 3px solid #17a2b8;
  padding: 10px 14px;
  font-family: "Courier New", monospace;
  font-size: 11px;
  color: #333;
  word-break: break-all;
  white-space: pre-wrap;
  margin: 0;
  border-radius: 4px;
  overflow-x: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/hl7viewer/add-mapping-dialog/add-mapping-dialog.component.scss","webpack://./../../../Git%20space/admin/standalone-hl7-viewer/src/app/hl7viewer/add-mapping-dialog/add-mapping-dialog.component.scss"],"names":[],"mappings":"AAGA;EACE,qBAAA;EACA,gBAAA;ACFF;;ADKA;EACE,4BAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;ACFF;;ADKA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;ACFF;;ADKA;EACE,kBAAA;EACA,SAAA;EACA,6BAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;ACFF;;ADKA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,2CAAA;EACA,sBAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;ACFF;;ADKA;EACE,oCAAA;EACA,uBAAA;EACA,qDAAA;EACA,aAAA;EACA,6CAAA;ACFF;;ADKA;EACE,oCAAA;EACA,qCAAA;EACA,qDAAA;EACA,uDAAA;ACFF;;ADMA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;ACHF;;ADMA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;ACHF;;ADMA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;ACHF;;ADMA;EACE,cAAA;EACA,sBAAA;ACHF;;ADQE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;ACLJ;;ADSA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;ACNF;;ADSA;EACE,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wCAAA;EACA,gCAAA;ACNF;ADQE;EACE,yCAAA;ACNJ;;ADUA;EACE,aAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;ACPF;;ADUA;EACE,OAAA;EACA,YAAA;ACPF;;ADUA;EACE,kBAAA;ACPF;ADSE;EACE,cAAA;EACA,iBAAA;ACPJ;;ADWA;EACE,cAAA;EACA,gBAAA;ACRF;;ADWA;EACE,eAAA;EACA,kBAAA;ACRF;ADUE;EACE,eAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;ACRJ;;ADYA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;ACTF;;ADYA;EACE,aAAA;EACA,uBAAA;EACA,cAAA;ACTF;;ADYA;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;ACTF;ADWE;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;ACTJ;ADWI;EACE,yBAAA;EACA,qBAAA;ACTN;ADaE;EACE,sBAAA;EACA,uCAAA;EACA,0BAAA;ACXJ;ADaI;EACE,yBAAA;EACA,sCAAA;ACXN;ADeE;EACE,iBAAA;ACbJ;;ADiBA;EACE,iBAAA;EACA,6BAAA;EACA,gBAAA;ACdF;ADgBE;EACE,cAAA;EACA,iBAAA;ACdJ;;ADkBA;EACE,cAAA;EACA,qCAAA;EACA,eAAA;EACA,qBAAA;ACfF;;ADmBA;EACE,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AChBF;;ADmBA;EACE,kBAAA;EACA,yBAAA;EACA,gCAAA;AChBF;ADkBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AChBJ;;ADoBA;EACE,oCAAA;EACA,uBAAA;EACA,8BAAA;ACjBF;ADmBE;EACE,uBAAA;ACjBJ;;ADqBA;EACE,aAAA;AClBF;;ADqBA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AClBF;;ADqBA;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,wEAAA;AClBF;ADoBE;EACE,qBAAA;EACA,UAAA;EACA,gDAAA;AClBJ;;ADsBA;EACE,kBAAA;EACA,eAAA;ACnBF;;ADsBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,iBAAA;EACA,6BAAA;ACnBF;;ADsBA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;ACnBF;ADqBE;EACE,yBAAA;EACA,qBAAA;ACnBJ;ADsBE;EACE,aAAA;EACA,mBAAA;ACpBJ;ADuBE;EACE,iBAAA;ACrBJ;;ADyBA;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,uCAAA;EACA,0BAAA;ACtBF;ADwBE;EACE,yBAAA;EACA,sCAAA;ACtBJ;ADyBE;EACE,iBAAA;ACvBJ;;AD2BA;EACE,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;ACxBF;AD0BE;EACE,iBAAA;ACxBJ;;AD6BA;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AC1BF;;AD6BA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;AC1BF;AD4BE;EACE,yBAAA;EACA,qBAAA;AC1BJ;AD6BE;EACE,iBAAA;AC3BJ;;ADgCA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AC7BF;;ADgCA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AC7BF;AD+BE;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;AC7BJ;;ADiCA;EACE,mBAAA;AC9BF;;ADkCE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AC/BJ;ADiCI;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AC/BN;ADkCI;EACE,OAAA;EACA,mBAAA;AChCN;;ADqCA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;AClCF;;ADqCA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;AClCF;;ADqCA;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AClCF;;ADuCE;EACE,yBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;ACpCJ;ADsCI;EACE,cAAA;EACA,eAAA;ACpCN;ADuCI;EACE,cAAA;ACrCN;ADwCI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ACtCN;ADyCI;EACE,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qCAAA;EACA,eAAA;EACA,cAAA;ACvCN;AD2CE;EACE,gBAAA;ACzCJ;AD2CI;EACE,kBAAA;EACA,eAAA;ACzCN;AD4CI;EACE,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,kBAAA;EACA,qCAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AC1CN","sourcesContent":["// Styles for Add Mapping Dialog\n// Improved UI decorations, paddings, and button placements\n\n::ng-deep .mat-dialog-container {\n  padding: 0 !important;\n  overflow: hidden;\n}\n\n.dialog-title {\n  padding: 20px 24px 16px 24px;\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  border-bottom: 1px solid #e0e0e0;\n  background-color: #f8f9fa;\n}\n\n.dialog-content {\n  padding: 24px;\n  font-size: 13px;\n  color: #333;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.dialog-actions {\n  padding: 16px 24px;\n  margin: 0;\n  border-top: 1px solid #e0e0e0;\n  background-color: #f8f9fa;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.Btn_confirm {\n  min-width: 80px;\n  padding: 6px 16px;\n  font-size: 12px;\n  border: 1px solid rgba(120, 130, 140, 0.13);\n  background-color: #fff;\n  color: rgba(0, 0, 0, 0.87);\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.Btn_confirm:focus {\n  background-color: #ffffff !important;\n  color: black !important;\n  border: 1px solid rgba(120, 130, 140, 0.2) !important;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.Btn_confirm:hover {\n  background-color: #f8f9fa !important;\n  color: rgba(0, 0, 0, 0.87) !important;\n  border: 1px solid rgba(120, 130, 140, 0.2) !important;\n  box-shadow: inset 0 -10rem 0px rgba(158, 158, 158, 0.2);\n}\n\n// Info Section\n.info-section {\n  padding: 16px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #e0e0e0;\n}\n\n.info-row {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.info-label {\n  min-width: 90px;\n  color: #495057;\n  font-weight: 600;\n}\n\n.info-value {\n  color: #6c757d;\n  word-break: break-word;\n}\n\n// Mappings Section\n.mappings-section {\n  .section-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #495057;\n    margin-bottom: 12px;\n  }\n}\n\n.no-mappings {\n  padding: 16px;\n  text-align: center;\n  font-style: italic;\n  color: #999;\n}\n\n.mapping-card {\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  background-color: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: box-shadow 0.2s ease;\n\n  &:hover {\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n  }\n}\n\n.mapping-card-body {\n  padding: 16px;\n}\n\n.mapping-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.mapping-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.mapping-label {\n  margin-bottom: 6px;\n  \n  strong {\n    color: #495057;\n    margin-right: 6px;\n  }\n}\n\n.mapping-alias {\n  color: #007bff;\n  font-weight: 500;\n}\n\n.mapping-path {\n  margin-top: 4px;\n  margin-bottom: 8px;\n  \n  small {\n    font-size: 11px;\n    word-break: break-all;\n    display: block;\n    line-height: 1.4;\n  }\n}\n\n.pending-badge {\n  font-size: 11px;\n  padding: 4px 8px;\n  margin-top: 6px;\n  display: inline-block;\n  background-color: #f0ad4e;\n  color: #fff;\n  border-radius: 0.25rem;\n  font-weight: bold;\n}\n\n.mapping-actions {\n  display: flex;\n  align-items: flex-start;\n  flex-shrink: 0;\n}\n\n.action-btn {\n  padding: 6px 12px;\n  font-size: 12px;\n  border-radius: 4px;\n  white-space: nowrap;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  \n  &.btn-danger {\n    background-color: #d9534f;\n    border-color: #d9534f;\n    color: #fff;\n    \n    &:hover:not([disabled]) {\n      background-color: #c9302c;\n      border-color: #c12e2a;\n    }\n  }\n  \n  &.btn-secondary {\n    background-color: #fff;\n    border-color: rgba(120, 130, 140, 0.13);\n    color: rgba(0, 0, 0, 0.87);\n    \n    &:hover:not([disabled]) {\n      background-color: #f8f9fa;\n      border-color: rgba(120, 130, 140, 0.2);\n    }\n  }\n  \n  i {\n    margin-right: 4px;\n  }\n}\n\n.mapping-condition {\n  padding-top: 12px;\n  border-top: 1px solid #e9ecef;\n  margin-top: 12px;\n  \n  strong {\n    color: #495057;\n    margin-right: 6px;\n  }\n}\n\n.condition-value {\n  color: #6c757d;\n  font-family: 'Courier New', monospace;\n  font-size: 11px;\n  word-break: break-all;\n}\n\n// Add Mapping Card\n.add-mapping-card {\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  background-color: #fff;\n  overflow: hidden;\n  margin-top: 20px;\n}\n\n.add-mapping-header {\n  padding: 12px 16px;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n  \n  h6 {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: #495057;\n  }\n}\n\n.highlight-active {\n  background-color: #17a2b8 !important;\n  color: white !important;\n  border-left: 4px solid #0c5460;\n  \n  h6 {\n    color: white !important;\n  }\n}\n\n.add-mapping-body {\n  padding: 20px;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #495057;\n  font-size: 13px;\n}\n\n.form-control {\n  padding: 10px 12px;\n  font-size: 13px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  \n  &:focus {\n    border-color: #80bdff;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n  }\n}\n\n.form-control-lg {\n  padding: 12px 14px;\n  font-size: 14px;\n}\n\n.form-actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding-top: 16px;\n  border-top: 1px solid #e9ecef;\n}\n\n.action-btn-primary {\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 4px;\n  background-color: #0275d8;\n  border-color: #0275d8;\n  color: #fff;\n  \n  &:hover:not([disabled]) {\n    background-color: #025aa5;\n    border-color: #01549b;\n  }\n  \n  &[disabled] {\n    opacity: 0.65;\n    cursor: not-allowed;\n  }\n  \n  i {\n    margin-right: 6px;\n  }\n}\n\n.action-btn-secondary {\n  padding: 8px 16px;\n  font-size: 13px;\n  border-radius: 4px;\n  background-color: #fff;\n  border-color: rgba(120, 130, 140, 0.13);\n  color: rgba(0, 0, 0, 0.87);\n  \n  &:hover:not([disabled]) {\n    background-color: #f8f9fa;\n    border-color: rgba(120, 130, 140, 0.2);\n  }\n  \n  i {\n    margin-right: 6px;\n  }\n}\n\n.info-text {\n  color: #6c757d;\n  font-size: 12px;\n  display: inline-flex;\n  align-items: center;\n  \n  i {\n    margin-right: 4px;\n  }\n}\n\n// Add Mapping Button Section\n.add-mapping-button-section {\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid #e9ecef;\n}\n\n.add-mapping-btn {\n  padding: 10px 20px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 4px;\n  background-color: #5cb85c;\n  border-color: #5cb85c;\n  color: #fff;\n  \n  &:hover:not([disabled]) {\n    background-color: #449d44;\n    border-color: #419641;\n  }\n  \n  i {\n    margin-right: 6px;\n  }\n}\n\n// Expression builder styles\n.expression-builder-section {\n  margin-top: 1rem;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #dee2e6;\n}\n\n.expression-toggle {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  \n  label {\n    margin-left: 0.5rem;\n    margin-bottom: 0;\n    cursor: pointer;\n  }\n}\n\n.function-select {\n  margin-bottom: 1rem;\n}\n\n.parameter-form {\n  .param-row {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0.5rem;\n    \n    label {\n      min-width: 120px;\n      margin-bottom: 0;\n      font-weight: 500;\n    }\n    \n    input, select {\n      flex: 1;\n      margin-left: 0.5rem;\n    }\n  }\n}\n\n.expression-preview {\n  margin-top: 1rem;\n  padding: 0.75rem;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  font-family: monospace;\n  font-size: 0.9em;\n  word-break: break-all;\n}\n\n.function-description {\n  font-size: 0.85em;\n  color: #6c757d;\n  font-style: italic;\n  margin-bottom: 0.75rem;\n}\n\n.category-label {\n  font-weight: 600;\n  color: #495057;\n  font-size: 0.8em;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n// Repeatable Mapping Indicator\n.repeatable-indicator {\n  .alert-info {\n    background-color: #e7f3ff;\n    border: 1px solid #b6d7f5;\n    border-left: 4px solid #17a2b8;\n    border-radius: 4px;\n    padding: 12px 16px;\n    font-size: 13px;\n    color: #0c5460;\n    \n    i {\n      color: #17a2b8;\n      font-size: 16px;\n    }\n    \n    strong {\n      color: #0c5460;\n    }\n    \n    p {\n      color: #0c5460;\n      font-size: 12px;\n      line-height: 1.5;\n    }\n    \n    code {\n      background-color: #d1ecf1;\n      padding: 2px 6px;\n      border-radius: 3px;\n      font-family: 'Courier New', monospace;\n      font-size: 12px;\n      color: #0c5460;\n    }\n  }\n  \n  .auto-expression-preview {\n    margin-top: 12px;\n    \n    .form-label {\n      margin-bottom: 6px;\n      font-size: 12px;\n    }\n    \n    .expression-code {\n      background-color: #f4f4f4;\n      border: 1px solid #ddd;\n      border-left: 3px solid #17a2b8;\n      padding: 10px 14px;\n      font-family: 'Courier New', monospace;\n      font-size: 11px;\n      color: #333;\n      word-break: break-all;\n      white-space: pre-wrap;\n      margin: 0;\n      border-radius: 4px;\n      overflow-x: auto;\n    }\n  }\n}\n","::ng-deep .mat-dialog-container {\n  padding: 0 !important;\n  overflow: hidden;\n}\n\n.dialog-title {\n  padding: 20px 24px 16px 24px;\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  border-bottom: 1px solid #e0e0e0;\n  background-color: #f8f9fa;\n}\n\n.dialog-content {\n  padding: 24px;\n  font-size: 13px;\n  color: #333;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.dialog-actions {\n  padding: 16px 24px;\n  margin: 0;\n  border-top: 1px solid #e0e0e0;\n  background-color: #f8f9fa;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.Btn_confirm {\n  min-width: 80px;\n  padding: 6px 16px;\n  font-size: 12px;\n  border: 1px solid rgba(120, 130, 140, 0.13);\n  background-color: #fff;\n  color: rgba(0, 0, 0, 0.87);\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.Btn_confirm:focus {\n  background-color: #ffffff !important;\n  color: black !important;\n  border: 1px solid rgba(120, 130, 140, 0.2) !important;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.Btn_confirm:hover {\n  background-color: #f8f9fa !important;\n  color: rgba(0, 0, 0, 0.87) !important;\n  border: 1px solid rgba(120, 130, 140, 0.2) !important;\n  box-shadow: inset 0 -10rem 0px rgba(158, 158, 158, 0.2);\n}\n\n.info-section {\n  padding: 16px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #e0e0e0;\n}\n\n.info-row {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.info-label {\n  min-width: 90px;\n  color: #495057;\n  font-weight: 600;\n}\n\n.info-value {\n  color: #6c757d;\n  word-break: break-word;\n}\n\n.mappings-section .section-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 12px;\n}\n\n.no-mappings {\n  padding: 16px;\n  text-align: center;\n  font-style: italic;\n  color: #999;\n}\n\n.mapping-card {\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  background-color: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: box-shadow 0.2s ease;\n}\n.mapping-card:hover {\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n.mapping-card-body {\n  padding: 16px;\n}\n\n.mapping-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.mapping-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.mapping-label {\n  margin-bottom: 6px;\n}\n.mapping-label strong {\n  color: #495057;\n  margin-right: 6px;\n}\n\n.mapping-alias {\n  color: #007bff;\n  font-weight: 500;\n}\n\n.mapping-path {\n  margin-top: 4px;\n  margin-bottom: 8px;\n}\n.mapping-path small {\n  font-size: 11px;\n  word-break: break-all;\n  display: block;\n  line-height: 1.4;\n}\n\n.pending-badge {\n  font-size: 11px;\n  padding: 4px 8px;\n  margin-top: 6px;\n  display: inline-block;\n  background-color: #f0ad4e;\n  color: #fff;\n  border-radius: 0.25rem;\n  font-weight: bold;\n}\n\n.mapping-actions {\n  display: flex;\n  align-items: flex-start;\n  flex-shrink: 0;\n}\n\n.action-btn {\n  padding: 6px 12px;\n  font-size: 12px;\n  border-radius: 4px;\n  white-space: nowrap;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n.action-btn.btn-danger {\n  background-color: #d9534f;\n  border-color: #d9534f;\n  color: #fff;\n}\n.action-btn.btn-danger:hover:not([disabled]) {\n  background-color: #c9302c;\n  border-color: #c12e2a;\n}\n.action-btn.btn-secondary {\n  background-color: #fff;\n  border-color: rgba(120, 130, 140, 0.13);\n  color: rgba(0, 0, 0, 0.87);\n}\n.action-btn.btn-secondary:hover:not([disabled]) {\n  background-color: #f8f9fa;\n  border-color: rgba(120, 130, 140, 0.2);\n}\n.action-btn i {\n  margin-right: 4px;\n}\n\n.mapping-condition {\n  padding-top: 12px;\n  border-top: 1px solid #e9ecef;\n  margin-top: 12px;\n}\n.mapping-condition strong {\n  color: #495057;\n  margin-right: 6px;\n}\n\n.condition-value {\n  color: #6c757d;\n  font-family: \"Courier New\", monospace;\n  font-size: 11px;\n  word-break: break-all;\n}\n\n.add-mapping-card {\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  background-color: #fff;\n  overflow: hidden;\n  margin-top: 20px;\n}\n\n.add-mapping-header {\n  padding: 12px 16px;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n}\n.add-mapping-header h6 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #495057;\n}\n\n.highlight-active {\n  background-color: #17a2b8 !important;\n  color: white !important;\n  border-left: 4px solid #0c5460;\n}\n.highlight-active h6 {\n  color: white !important;\n}\n\n.add-mapping-body {\n  padding: 20px;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #495057;\n  font-size: 13px;\n}\n\n.form-control {\n  padding: 10px 12px;\n  font-size: 13px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n.form-control:focus {\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.form-control-lg {\n  padding: 12px 14px;\n  font-size: 14px;\n}\n\n.form-actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding-top: 16px;\n  border-top: 1px solid #e9ecef;\n}\n\n.action-btn-primary {\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 4px;\n  background-color: #0275d8;\n  border-color: #0275d8;\n  color: #fff;\n}\n.action-btn-primary:hover:not([disabled]) {\n  background-color: #025aa5;\n  border-color: #01549b;\n}\n.action-btn-primary[disabled] {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n.action-btn-primary i {\n  margin-right: 6px;\n}\n\n.action-btn-secondary {\n  padding: 8px 16px;\n  font-size: 13px;\n  border-radius: 4px;\n  background-color: #fff;\n  border-color: rgba(120, 130, 140, 0.13);\n  color: rgba(0, 0, 0, 0.87);\n}\n.action-btn-secondary:hover:not([disabled]) {\n  background-color: #f8f9fa;\n  border-color: rgba(120, 130, 140, 0.2);\n}\n.action-btn-secondary i {\n  margin-right: 6px;\n}\n\n.info-text {\n  color: #6c757d;\n  font-size: 12px;\n  display: inline-flex;\n  align-items: center;\n}\n.info-text i {\n  margin-right: 4px;\n}\n\n.add-mapping-button-section {\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid #e9ecef;\n}\n\n.add-mapping-btn {\n  padding: 10px 20px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 4px;\n  background-color: #5cb85c;\n  border-color: #5cb85c;\n  color: #fff;\n}\n.add-mapping-btn:hover:not([disabled]) {\n  background-color: #449d44;\n  border-color: #419641;\n}\n.add-mapping-btn i {\n  margin-right: 6px;\n}\n\n.expression-builder-section {\n  margin-top: 1rem;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #dee2e6;\n}\n\n.expression-toggle {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n.expression-toggle label {\n  margin-left: 0.5rem;\n  margin-bottom: 0;\n  cursor: pointer;\n}\n\n.function-select {\n  margin-bottom: 1rem;\n}\n\n.parameter-form .param-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n.parameter-form .param-row label {\n  min-width: 120px;\n  margin-bottom: 0;\n  font-weight: 500;\n}\n.parameter-form .param-row input, .parameter-form .param-row select {\n  flex: 1;\n  margin-left: 0.5rem;\n}\n\n.expression-preview {\n  margin-top: 1rem;\n  padding: 0.75rem;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  font-family: monospace;\n  font-size: 0.9em;\n  word-break: break-all;\n}\n\n.function-description {\n  font-size: 0.85em;\n  color: #6c757d;\n  font-style: italic;\n  margin-bottom: 0.75rem;\n}\n\n.category-label {\n  font-weight: 600;\n  color: #495057;\n  font-size: 0.8em;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.repeatable-indicator .alert-info {\n  background-color: #e7f3ff;\n  border: 1px solid #b6d7f5;\n  border-left: 4px solid #17a2b8;\n  border-radius: 4px;\n  padding: 12px 16px;\n  font-size: 13px;\n  color: #0c5460;\n}\n.repeatable-indicator .alert-info i {\n  color: #17a2b8;\n  font-size: 16px;\n}\n.repeatable-indicator .alert-info strong {\n  color: #0c5460;\n}\n.repeatable-indicator .alert-info p {\n  color: #0c5460;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.repeatable-indicator .alert-info code {\n  background-color: #d1ecf1;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-family: \"Courier New\", monospace;\n  font-size: 12px;\n  color: #0c5460;\n}\n.repeatable-indicator .auto-expression-preview {\n  margin-top: 12px;\n}\n.repeatable-indicator .auto-expression-preview .form-label {\n  margin-bottom: 6px;\n  font-size: 12px;\n}\n.repeatable-indicator .auto-expression-preview .expression-code {\n  background-color: #f4f4f4;\n  border: 1px solid #ddd;\n  border-left: 3px solid #17a2b8;\n  padding: 10px 14px;\n  font-family: \"Courier New\", monospace;\n  font-size: 11px;\n  color: #333;\n  word-break: break-all;\n  white-space: pre-wrap;\n  margin: 0;\n  border-radius: 4px;\n  overflow-x: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
